// generated by the plop

import { PROGRESS_STATUSES, UUID } from 'symbols';
import { TemplateModel } from '../../../pdf-templates/symbols';
import { TalonModel } from '../../symbols';

export interface TalonManageStateModel {
  currentTalonId: UUID;
  talons: { [talonId: string]: TalonModel };
  loadTalonStatus: PROGRESS_STATUSES;
  updateTalonStatus: PROGRESS_STATUSES;
  realVersionTalons: { [talonId: string]: TalonModel };
  templateList: TemplateModel[];
  loadTemplateListStatus: PROGRESS_STATUSES;
}

export const TALON_MANAGE_STATE_DEFAULT: TalonManageStateModel = {
  currentTalonId: null,
  talons: {},
  loadTalonStatus: PROGRESS_STATUSES.NOT_INITIALIZED,
  updateTalonStatus: PROGRESS_STATUSES.NOT_INITIALIZED,
  realVersionTalons: {},
  templateList: [],
  loadTemplateListStatus: PROGRESS_STATUSES.NOT_INITIALIZED
};
